import { Textarea } from "ui/components/textarea";
import { Button } from "ui/components/button";
import { ArrowUpRight, Loader2 } from "lucide-react";

export const SearchBar = ({ requirement, error, onSubmit, onChange, isLoading }) => {
  return (
    <div className="w-full searchbar flex flex-col p-1 gap-2 border border-gray-200 rounded-md mb-2">
      <div className="flex flex-col gap-1">
        <Textarea
          placeholder="Enter Requirement"
          rows={5}
          className={`w-full max-h-25 pl-2 py-2 text-muted-foreground text-sm resize-none border-none transition-none shadow-none focus-visible:ring-0 min-h-[40px] ${
            error ? "border-red-500" : ""
          } custom-scroll`}
          value={requirement}
          onChange={onChange}
          disabled={isLoading}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault(); 
              onSubmit();         
            }
          }}
          
        />
        {error && <span className="ml-2 text-sm text-red-500">{error}</span>}
      </div>
      <Button
        size="default"
        variant="black"
        className="self-end mr-2  mb-2 cursor-pointer"
        onClick={onSubmit}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2 className=" animate-spin" />
        ) : (
          <ArrowUpRight className="-rotate-45" />
        )}
      </Button>
    </div>
  );
};